import React, { Component } from 'react'
import './index.scss'
import Axios from '../../request'
import logo from '../../assets/logo.png'
import hotWord from '../../assets/hotword.png'
export default class Hotwords extends Component {
  state = {
    rankArr: [],
  }
  getData = () => {
    Axios.jsonp({ url: '/api/vote/category/order' }).then((res) => {
      this.setState({
        // rankArr: res.map(obj => Object.keys(obj)),
        rankArr:res
      })
      // console.log(this.state.rankArr)
    })
  }
  componentDidMount() {
    this.getData()
  }
  render() {
    const { rankArr } = this.state
    return (
      <div className="conBox bg" data-component="hotWords">
        {/* <img className="logo" src={logo} alt="logo" /> */}
        <img className="titleIcon" src={hotWord} alt="logo" />
        <ul className="rankList">
          {rankArr.map((item, index) => (
            <li className="rankItem" key={index}>
              {index === 0 ? (
                <span className="rankIndex rank1"></span>
              ) : index === 1 ? (
                <span className="rankIndex rank2"></span>
              ) : index === 2 ? (
                <span className="rankIndex rank3"></span>
              ) : (
                <span className="rankIndex">{index + 1}</span>
              )}
              <span className={`hotName ${index == 0 || index == 2 ? 'redHotName' : ''} ${index == 1 ? 'redHotName2' : ''} ${index == 4 || index == 6 || index == 8 ? 'redHotName3' : ''}`}>
                {item}
              </span>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}
